import React from 'react';
import styled from 'styled-components';

const PrivacyText = styled.span`
  ${props => props.theme?.privacyLabel};
`;

export default function PrivacyLabel({text}) {
  return <PrivacyText>{text}</PrivacyText>;
}
